import React from 'react';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { SimpleButton } from '@/components/Simple/SimpleButton';
import i18n from '@/locales/init';
import { IReadingRecordItem } from '@/api/history';
import lessModule from './item.module.less';
export interface IReadingRecordItemProps {
  item: IReadingRecordItem;
  onHomePage?: boolean;
}

export const ListeningRecordItem = React.memo<IReadingRecordItemProps>(({
  item, onHomePage
}) => {

  const statusText = ['',i18n.t('common.dauyan_not_done'), i18n.t('common.dauyan_some_complete')][item.status];
  return <div className={classNames(lessModule.itemWrapper, onHomePage && lessModule.onHomePage)} onClick={()=>{
    window.open(window.location.origin + `/listening/#/listening-qa/${item.paper_id}?record_id=${item.id}`);
  }}>
    <div className={lessModule.title}>{item.title}</div>
    {!onHomePage && <div className={lessModule.done}>{item.correct_num || item.total_num ? item.correct_num + '/' + item.total_num : '--'}</div>}
    <div className={lessModule.type}>
      <div className={classNames(lessModule.status, item.status === 2 ? lessModule.complete: '' )}>{statusText}</div>
    </div>
    <div className={lessModule.time}>{dayjs(item.create_time * 1000).format('YYYY-MM-DD HH:mm')}</div>
    {
      !onHomePage && item.status === 2 && <div className={lessModule.redo}>
        <SimpleButton data-track-key={'history-listening-qa'} className={lessModule.button} onClick={(e)=>{
          e.stopPropagation();
          e.preventDefault();
          window.open(window.location.origin + `/listening/#/listening-qa/${item.paper_id}`);
        }}>{i18n.t('common.dauyan_more_tool_redo')}</SimpleButton>
        <SimpleButton data-track-key={'history-listening-en'} className={lessModule.button} onClick={(e)=>{
          e.stopPropagation();
          e.preventDefault();
          window.open(window.location.origin + `/listening/#/listening-enhance/${item.paper_id}`);
        }}>{i18n.t('common.dauyan_listening_sentence')}</SimpleButton>
      </div>
    }
  </div>;
});